<div class="container">
    <div class="input-box">
        <kendo-combobox [popupSettings]="{width: 350}" #finder [data]="kDataSource | async" textField="shortName"
            valueField="id" [clearButton]="false" [listHeight]="420" [loading]="isFinderLoading" [filterable]="true"
            (valueChange)="onValueChange($event)" (filterChange)="onFinderFilterChange($event)"
            (focus)="onFinderFocus()" style="width: 100%;">
            <ng-template kendoComboBoxItemTemplate let-dataItem>
                <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
            </ng-template>
        </kendo-combobox>
    </div>
    <div class="button-box">
        <button tid="plus_one_degree" tam-button tamType="primary" [tamInvert]="currentState.status !== 'oneDegree'"
            (click)="onStatusChange('oneDegree')">1&deg;</button>
        <button tid="entity_all" tam-button tamType="primary" [tamInvert]="currentState.status !== 'all'"
            (click)="onStatusChange('all')">All</button>
    </div>
</div>